export const types = {
  GET_SOLUCIONES_BEGINS: 'FILTERS/GET_SOLUCIONES_BEGINS',
  GET_SOLUCIONES_SUCCESS: 'FILTERS/GET_SOLUCIONES_SUCCESS',
  GET_SOLUCIONES_FAILURE: 'FILTERS/GET_SOLUCIONES_FAILURE',
};

export const initialState = {
  solucionesList: [],
};

const Soluciones = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SOLUCIONES_BEGINS:
      return {
        ...state,
        solucionesListState: 'FETCHING',
        id: action.payload,
      };
    case types.GET_SOLUCIONES_SUCCESS:
      return {
        ...state,
        solucionesListState: 'SUCCESS',
        solucionesList: action.payload,
      };
    case types.GET_SOLUCIONES_FAILURE:
      return {
        ...state,
        solucionesListState: 'FAILURE',
      };
    default:
      return { ...state };
  }
};

export const actions = {
  getSolucionesBegins: alias => ({
    type: types.GET_SOLUCIONES_BEGINS,
    payload: { alias },
  }),
  getSolucionesSuccess: data => ({
    type: types.GET_SOLUCIONES_SUCCESS,
    payload: data,
  }),
  getSolucionesFailure: () => ({ type: types.GET_SOLUCIONES_FAILURE }),
};

export default Soluciones;
